import styled from "styled-components";

export const WalletWrapper = styled.div``;

export const WalletInnerWrapper = styled.div<{ inset: number | null }>`
  margin-top: ${(p) => (p.inset ? p.inset + 73 : 73)}px;
`;

export const WalletNoData = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: var(--Black-300, #808080);
  font-weight: 500;
  font-size: 16px;
`;
